export const promote = (config) => {
    const { secret: _secret, ...rest } = config;
    return {
        ...rest,
        requestMethod: 'POST'
    };
};
//# sourceMappingURL=webhook-webhook-1-to-2.js.map